import { appendEnvVars, readEnvVar } from '@cli-utils/files.js'
import { detectDevPort } from '@next-adapter/init/scaffolders/dev-server/detect-dev-port.js'
import { getCoreEnvSections } from './get-core-env-sections.js'
import { shouldOverwriteAuthUrl } from './should-overwrite-auth-url.js'

export function scaffoldEnv(
  cwd: string,
  options: { databaseUrl?: string; namespace?: string }
): { added: string[]; skipped: string[]; updated: string[] } {
  const devPort = detectDevPort(cwd)
  const sections = getCoreEnvSections(options.databaseUrl, devPort, options.namespace ?? 'admin')
  const authBasePath = `/api/${options.namespace ?? 'admin'}/auth`
  const overwrite = new Set<string>()
  if (options.databaseUrl) {
    overwrite.add('DATABASE_URL')
  }
  if (shouldOverwriteAuthUrl(cwd, devPort)) {
    overwrite.add('BETTERSTART_AUTH_URL')
  }
  if (readEnvVar(cwd, 'BETTERSTART_AUTH_BASE_PATH') !== authBasePath) {
    overwrite.add('BETTERSTART_AUTH_BASE_PATH')
  }

  return appendEnvVars(cwd, sections, overwrite)
}
